// Thin wrapper around the window.trybe API injected by the Trybe attribution
// pixel (see index.html). MemCase is a fully custom site, not Shopify/
// WooCommerce, so the pixel's autoTracking is off and every event here is
// sent manually per https://jointrybe.com/help/brand-guides/trybe-pixel-and-orders-api.
export interface TrybeCheckoutData {
    orderId: string;
    value: number;
    currency: string;
    email?: string;
}

declare global {
    interface Window {
        trybe?: {
            productViewed: (data: { productId: string; productName?: string; price: number; currency: string; category?: string }) => void;
            addToCart: (data: { productId: string; productName?: string; quantity?: number; price: number; currency: string }) => void;
            checkout: (data: TrybeCheckoutData) => void;
            track: (eventName: string, properties?: Record<string, unknown>) => void;
            getVisitorId: () => string;
        };
    }
}

// The pixel script loads asynchronously from <head>, so window.trybe may not
// exist yet for an interaction that happens in the first instant of a page
// load - swallow that instead of throwing from a tracking call.
export function trybeTrack(eventName: string, properties: Record<string, unknown> = {}) {
    try {
        window.trybe?.track(eventName, properties);
    } catch (err) {
        console.error("[Trybe] track failed:", err);
    }
}

export function trybeCheckout(data: TrybeCheckoutData) {
    try {
        window.trybe?.checkout(data);
    } catch (err) {
        console.error("[Trybe] checkout failed:", err);
    }
}

export function trybeGetVisitorId(): string | null {
    try {
        return window.trybe?.getVisitorId() ?? null;
    } catch {
        return null;
    }
}
